var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login-page app-form-surface"
  }, [_c('div', {
    staticClass: "login-page__backdrop",
    style: {
      '--login-hero-image': `url(${_vm.loginHeroImage})`
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('div', {
    staticClass: "background-gradient",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "hero-section"
  }, [_c('div', {
    staticClass: "hero-content"
  }, [_c('div', {
    staticClass: "brand-section"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('v-icon', {
    staticClass: "logo-icon",
    attrs: {
      "size": "40",
      "color": "white"
    }
  }, [_vm._v("mdi-music-note")])], 1), _vm._m(0), _c('p', {
    staticClass: "hero-subtitle"
  }, [_vm._v(" Join thousands of companies using Cuetrics to streamline their audition process, manage performers, and find the perfect talent with real-time scoring and comprehensive tools. ")])]), _c('div', {
    staticClass: "features-grid"
  }, [_c('div', {
    staticClass: "feature-item"
  }, [_c('span', {
    staticClass: "feature-icon-wrap",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('v-icon', {
    staticClass: "feature-icon",
    attrs: {
      "size": "22"
    }
  }, [_vm._v("mdi-chart-line")])], 1), _vm._m(1)]), _c('div', {
    staticClass: "feature-item"
  }, [_c('span', {
    staticClass: "feature-icon-wrap",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('v-icon', {
    staticClass: "feature-icon",
    attrs: {
      "size": "22"
    }
  }, [_vm._v("mdi-video")])], 1), _vm._m(2)]), _c('div', {
    staticClass: "feature-item"
  }, [_c('span', {
    staticClass: "feature-icon-wrap",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('v-icon', {
    staticClass: "feature-icon",
    attrs: {
      "size": "22"
    }
  }, [_vm._v("mdi-account-multiple")])], 1), _vm._m(3)])])])]), _c('div', {
    staticClass: "form-section"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "form-header"
  }, [_c('img', {
    staticClass: "form-brand-logo",
    attrs: {
      "src": _vm.cuetricsLogo,
      "alt": "CUETRICS"
    }
  }), _c('p', {
    staticClass: "form-subtitle"
  }, [_vm._v("Sign in to your account")])]), _c('v-form', {
    ref: "form",
    staticClass: "login-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-4 login-field",
    attrs: {
      "type": "email",
      "rules": [_vm.rules.required, _vm.rules.email],
      "outlined": "",
      "dense": "",
      "dark": "",
      "required": "",
      "label": "Email address",
      "placeholder": "Enter your email"
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  }), _c('v-text-field', {
    class: ['mb-4', 'login-field'],
    attrs: {
      "type": _vm.showPassword ? 'text' : 'password',
      "rules": [_vm.rules.required],
      "outlined": "",
      "dense": "",
      "dark": "",
      "required": "",
      "autocomplete": "current-password",
      "label": "Password",
      "placeholder": "Enter your password",
      "append-icon": _vm.showPassword ? 'mdi-eye-off' : 'mdi-eye'
    },
    on: {
      "click:append": function ($event) {
        _vm.showPassword = !_vm.showPassword;
      }
    },
    model: {
      value: _vm.form.password,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  }), _vm.hasError ? _c('v-alert', {
    staticClass: "error-alert",
    attrs: {
      "type": "error",
      "dense": "",
      "text": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm._e(), _c('div', {
    staticClass: "form-options"
  }, [_c('v-checkbox', {
    staticClass: "remember-checkbox",
    attrs: {
      "label": "Remember me",
      "color": "primary",
      "dark": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.rememberMe,
      callback: function ($$v) {
        _vm.$set(_vm.form, "rememberMe", $$v);
      },
      expression: "form.rememberMe"
    }
  }), _c('v-btn', {
    staticClass: "forgot-link login-text-btn",
    attrs: {
      "text": "",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        _vm.showForgotPassword = true;
      }
    }
  }, [_vm._v(" Forgot password? ")])], 1), _c('v-btn', {
    staticClass: "mb-4 submit-btn login-submit-btn",
    attrs: {
      "type": "submit",
      "color": "primary",
      "dark": "",
      "block": "",
      "loading": _vm.loading,
      "disabled": !_vm.valid || _vm.loading,
      "elevation": "2"
    }
  }, [!_vm.loading ? _c('span', [_vm._v("Sign in")]) : _c('span', [_vm._v("Signing in...")])])], 1), _c('div', {
    staticClass: "registration-link"
  }, [_c('div', {
    staticClass: "registration-content"
  }, [_c('p', {
    staticClass: "registration-text"
  }, [_vm._v(" Don't have an account? "), _c('button', {
    staticClass: "signup-text-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/register');
      }
    }
  }, [_vm._v(" Create Account ")])]), _c('p', {
    staticClass: "version-text"
  }, [_vm._v("v1.8.05.26")])])])], 1)]), _c('PWAInstallPrompt')], 1), _vm.showInstallButton ? _c('div', {
    staticClass: "install-button-outside"
  }, [_c('v-btn', {
    staticClass: "install-app-btn",
    attrs: {
      "block": "",
      "color": "primary",
      "dark": "",
      "elevation": "2"
    },
    on: {
      "click": function ($event) {
        _vm.showInstallDialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-download")]), _vm._v(" Install App ")], 1)], 1) : _vm._e()]), _c('footer', {
    staticClass: "login-footer"
  }, [_c('div', {
    staticClass: "login-footer__inner"
  }, [_c('router-link', {
    staticClass: "login-footer__link",
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v("Privacy Policy")]), _c('span', {
    staticClass: "login-footer__sep",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("·")]), _c('router-link', {
    staticClass: "login-footer__link",
    attrs: {
      "to": "/terms"
    }
  }, [_vm._v("Terms of Service")])], 1)]), _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "persistent": ""
    },
    model: {
      value: _vm.showInstallDialog,
      callback: function ($$v) {
        _vm.showInstallDialog = $$v;
      },
      expression: "showInstallDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-cellphone-link")]), _vm._v(" Install Cuetrics ")], 1), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('p', {
    staticClass: "mb-4"
  }, [_vm._v(" Install the app on your device for quick access and push notifications. ")]), _vm.isIOS ? _c('div', {
    staticClass: "install-instructions"
  }, [_c('h3', {
    staticClass: "mb-3"
  }, [_vm._v("iPhone/iPad:")]), _c('div', {
    staticClass: "step-list"
  }, [_c('div', {
    staticClass: "step-item"
  }, [_c('v-icon', {
    staticClass: "step-icon",
    attrs: {
      "size": "20"
    }
  }, [_vm._v("mdi-share-variant")]), _c('span', [_vm._v("Tap the "), _c('strong', [_vm._v("Share")]), _vm._v(" button at the bottom")])], 1), _c('div', {
    staticClass: "step-item"
  }, [_c('v-icon', {
    staticClass: "step-icon",
    attrs: {
      "size": "20"
    }
  }, [_vm._v("mdi-plus-circle")]), _c('span', [_vm._v("Scroll and tap "), _c('strong', [_vm._v("\"Add to Home Screen\"")])])], 1), _c('div', {
    staticClass: "step-item"
  }, [_c('v-icon', {
    staticClass: "step-icon",
    attrs: {
      "size": "20"
    }
  }, [_vm._v("mdi-check")]), _c('span', [_vm._v("Tap "), _c('strong', [_vm._v("\"Add\"")]), _vm._v(" to confirm")])], 1)])]) : _c('div', {
    staticClass: "install-instructions"
  }, [_c('h3', {
    staticClass: "mb-3"
  }, [_vm._v("Android/Chrome:")]), _c('div', {
    staticClass: "step-list"
  }, [_c('div', {
    staticClass: "step-item"
  }, [_c('v-icon', {
    staticClass: "step-icon",
    attrs: {
      "size": "20"
    }
  }, [_vm._v("mdi-menu")]), _c('span', [_vm._v("Tap the "), _c('strong', [_vm._v("menu")]), _vm._v(" icon (3 dots) in the top right")])], 1), _c('div', {
    staticClass: "step-item"
  }, [_c('v-icon', {
    staticClass: "step-icon",
    attrs: {
      "size": "20"
    }
  }, [_vm._v("mdi-download")]), _c('span', [_vm._v("Look for "), _c('strong', [_vm._v("\"Install\"")]), _vm._v(" or "), _c('strong', [_vm._v("\"Add to Home Screen\"")])])], 1), _c('div', {
    staticClass: "step-item"
  }, [_c('v-icon', {
    staticClass: "step-icon",
    attrs: {
      "size": "20"
    }
  }, [_vm._v("mdi-check")]), _c('span', [_vm._v("Tap "), _c('strong', [_vm._v("\"Install\"")]), _vm._v(" to add the app")])], 1)]), _c('v-alert', {
    staticClass: "mt-4",
    attrs: {
      "type": "info",
      "outlined": "",
      "dense": ""
    }
  }, [_c('small', [_vm._v("If you don't see the install option, the browser may show it automatically, or you may need to use HTTPS.")])])], 1)]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.showInstallDialog = false;
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "400",
      "persistent": ""
    },
    model: {
      value: _vm.showForgotPassword,
      callback: function ($$v) {
        _vm.showForgotPassword = $$v;
      },
      expression: "showForgotPassword"
    }
  }, [_c('v-card', {
    staticClass: "forgot-dialog",
    attrs: {
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "dialog-title"
  }, [_vm._v(" Reset your password ")]), _c('v-card-text', {
    staticClass: "dialog-content"
  }, [_c('p', {
    staticClass: "dialog-description"
  }, [_vm._v(" Enter your email address and we'll send you a link to reset your password. ")]), _c('v-text-field', {
    staticClass: "login-field",
    attrs: {
      "label": "Email address",
      "type": "email",
      "outlined": "",
      "dense": "",
      "dark": "",
      "rules": [_vm.rules.required, _vm.rules.email],
      "placeholder": "Enter your email"
    },
    model: {
      value: _vm.forgotPasswordEmail,
      callback: function ($$v) {
        _vm.forgotPasswordEmail = $$v;
      },
      expression: "forgotPasswordEmail"
    }
  })], 1), _c('v-card-actions', {
    staticClass: "dialog-actions"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showForgotPassword = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c('v-btn', {
    staticClass: "reset-link-btn login-submit-btn",
    attrs: {
      "color": "primary",
      "loading": _vm.forgotPasswordLoading,
      "disabled": _vm.forgotPasswordLoading
    },
    on: {
      "click": _vm.handleForgotPassword
    }
  }, [_vm._v(" Send reset link ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', {
    staticClass: "hero-title font-display"
  }, [_vm._v(" Professional "), _c('span', {
    staticClass: "accent-text"
  }, [_vm._v("Audition Management")]), _vm._v(" for the Modern Stage ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "feature-content"
  }, [_c('h3', {
    staticClass: "feature-title"
  }, [_vm._v("Real-time Scoring")]), _c('p', {
    staticClass: "feature-description"
  }, [_vm._v("Live judging with instant feedback and aggregation")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "feature-content"
  }, [_c('h3', {
    staticClass: "feature-title"
  }, [_vm._v("Video Recording")]), _c('p', {
    staticClass: "feature-description"
  }, [_vm._v("Capture auditions with high-quality video and audio")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "feature-content"
  }, [_c('h3', {
    staticClass: "feature-title"
  }, [_vm._v("Talent Management")]), _c('p', {
    staticClass: "feature-description"
  }, [_vm._v("Comprehensive performer profiles and materials")])]);

}]

export { render, staticRenderFns }